import { Link } from "react-router-dom";
import { format_date, resolveImageUrl } from "../Utils/helpers";

const AVATAR_FALLBACK = "images/avatar.png";

export default function DriverSummaryCard({ driver }) {
    if (!driver?._id && !driver?.firstName) return null;

    const fullName = [driver?.firstName, driver?.lastName].filter(Boolean).join(" ") || "Driver";
    const profileSrc = resolveImageUrl(driver?.profileImage, AVATAR_FALLBACK);
    const memberSince = driver?.createdAt ? format_date(driver.createdAt, "MMM YYYY") : null;

    return (
        <div className="vehicle-driver-card">
            <div className="vehicle-driver-card__avatar-wrap">
                <img
                    src={profileSrc}
                    alt={fullName}
                    className="vehicle-driver-card__avatar"
                    onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = AVATAR_FALLBACK;
                    }}
                />
            </div>
            <div className="vehicle-driver-card__body">
                <span className="vehicle-driver-card__label">Driver</span>
                <h4 className="vehicle-driver-card__name text-capitalize">{fullName}</h4>
                {driver?.email && (
                    <p className="vehicle-driver-card__meta mb-1">{driver.email}</p>
                )}
                {driver?.phone && (
                    <p className="vehicle-driver-card__meta mb-0">{driver.phone}</p>
                )}
                {memberSince && (
                    <p className="vehicle-driver-card__meta mb-0 mt-1">Member since {memberSince}</p>
                )}
            </div>
            {driver?._id && (
                <Link
                    to={`/mover-management/mover-details/${driver._id}`}
                    className="vehicle-driver-card__link"
                >
                    View Profile
                </Link>
            )}
        </div>
    );
}
